/**
 * Datos de noticias y actualidad de Intercasa
 * Incluye las 10 noticias iniciales con información completa
 */

export const newsData = [
  {
    id: 1,
    title: 'La salsa de tomate más sana de España se hace en Tirajana',
    summary: 'Según los datos de Open Food Facts, organización internacional sin ánimo de lucro dedicada a ofrecer información transparente sobre los alimentos, la salsa de tomate más saludable de España se elabora en el sur de Gran Canaria.',
    content: `
      <p>La salsa de tomate Intercasa, producida en Juan Grande y perteneciente al Grupo Martinón, ha sido reconocida por Open Food Facts como la salsa de tomate más saludable de España. Dentro de los productos "Elaborado en Canarias", es el único que supera todos los parámetros de calidad nutricional analizados.</p>
      
      <p>El producto destaca por su composición: 0% de grasas totales y saturadas, solo un 1% de sal, un 8% menos de hidratos de carbono y un 21% más de proteínas respecto a la media del sector. Estos indicadores la posicionan como una referencia en su categoría.</p>
      
      <p>Con 71 años de trayectoria, Intercasa cuenta con un sólido arraigo en el mercado canario. La calidad demostrada refuerza su potencial para competir también en segmentos de mayor valor, incluyendo espacios gourmet, contribuyendo a la proyección del destino y del tejido empresarial local.</p>
    `,
    date: '2024-03-04',
    slug: 'salsa-tomate-mas-sana-espana',
    imageUrl: '/images/noticias/fabrica-noticia-1.webp',
    imageAlt: 'Salsa de tomate Intercasa reconocida como la más saludable de España',
    category: 'Calidad',
    source: 'Nayra Santana - Maspalomas24h',
    gallery: [
      '/images/noticias/intercasa-fabrica-1.webp',
      '/images/noticias/la-salsa-mas-sana.webp',
      '/images/noticias/intercasa-fabrica-3.webp'
    ]
  },
  {
    id: 2,
    title: 'Intercasa: La empresa que desarrolla varios tipos de salsas',
    summary: 'Intercasa es líder del mercado canario con el producto ketchup y ahora está inmerso en un proyecto de modernización y relanzamiento de marca consistente en la diversificación de productos y captación de nuevos mercados.',
    content: `
      <p>Intercasa ha avanzado en un proceso continuo de modernización, renovando sus instalaciones y líneas de producción, incorporando nuevos formatos y desarrollando nuevas fórmulas de salsas. La compañía se encuentra en crecimiento, aumentando su volumen de producción y abriendo mercados de exportación hacia África y América. Desde su fábrica en Juan Grande, en Gran Canaria, se diseñan y distribuyen todos sus productos, actualmente inmersos en un nuevo plan de mejora tecnológica.</p>
      
      <p>Comprometida con la calidad y la salud del consumidor, Intercasa garantiza que sus salsas no contienen gluten ni lactosa y que pasan rigurosos controles antes de su comercialización. Fundada en 1949 en Las Palmas de Gran Canaria, la empresa se trasladó a Juan Grande en 1973 para ampliar capacidad y acercarse a las zonas de cultivo. Durante los años 80 vivió un notable crecimiento, exportando a la Península y a países como Estados Unidos, y ampliando su catálogo con productos como mostaza dulce, salsa barbacoa, alioli receta canaria, mayonesa, kétchup Zero y tomate frito.</p>
      
      <p>Su apuesta por la innovación también se refleja en nuevos formatos (envases antigoteo, biberones de gran capacidad, cubos y garrafas) y en la diversificación hacia la producción para otras marcas. La renovación de su imagen corporativa consolida esta evolución. Entre sus próximos lanzamientos destacan nuevas referencias en formatos antigoteo y biberón, junto a productos ya presentes en el mercado como el tomate frito.</p>
    `,
    date: '2023-06-17',
    slug: 'intercasa-empresa-desarrolla-salsas',
    imageUrl: '/images/noticias/intercasa-salsas.webp',
    imageAlt: 'Intercasa: La empresa que desarrolla varios tipos de salsas',
    category: 'Empresa',
    source: 'Renata Domingo - El Día',
    gallery: []
  },
  {
    id: 3,
    title: 'Yonay Alemán: "Escuchar al público, la clave de nuestras nuevas salsas"',
    summary: 'Intercasa, con 76 años de historia en Canarias, inicia una nueva etapa de renovación corporativa. La actualización de su imagen responde a la evolución de la empresa y a la ampliación de su catálogo más allá del tradicional kétchup.',
    content: `
      <p>Intercasa continúa ampliando su catálogo con nuevas salsas y formatos, como alioli, mayonesa o envases antigoteo; fruto de una escucha activa al consumidor y de su experiencia en la elaboración de salsas. La empresa mantiene una apuesta constante por la innovación, desarrollando nuevas recetas y mejorando las existentes, entre ellas su exitoso kétchup cero, elaborado sin azúcar añadido y con ingredientes de alta calidad.</p>
      
      <p>La compañía refuerza también su compromiso con la alimentación saludable, ofreciendo productos sin gluten ni lactosa y garantizando la máxima transparencia en sus etiquetas. Su desarrollo de sabores está estrechamente vinculado a los gustos del consumidor canario, que identifica claramente el sabor característico de Intercasa y ha acogido positivamente nuevas variedades.</p>
      
      <p>Además, Intercasa potencia su conexión con el territorio trabajando con proveedores locales y favoreciendo procesos productivos en Canarias. Entre sus principales retos destacan la inversión continua en modernización industrial, el avance en sostenibilidad a través de energías renovables y materiales reciclados y la expansión hacia nuevos mercados, especialmente en América, sin dejar de consolidar su liderazgo en el archipiélago.</p>
    `,
    date: '2025-09-09',
    slug: 'yonay-aleman-escuchar-publico-nuevas-salsas',
    imageUrl: '/images/noticias/intercasa-ketchup-1.webp',
    imageAlt: 'Yonay Alemán habla sobre las nuevas salsas de Intercasa',
    category: 'Innovación',
    source: 'La Tribuna de Canarias',
    gallery: [
      '/images/noticias/intercasa-ketchup-1.webp',
      '/images/noticias/yonay-aleman-escuchar-publico.webp'
    ]
  },
  {
    id: 4,
    title: 'Kétchup 0% azúcares añadidos, la última apuesta de Intercasa',
    summary: 'La mayoría de los canarios identifica a Intercasa por su emblemático kétchup, el producto más histórico y reconocido de la marca. No obstante, la empresa ha ampliado con éxito su gama de salsas.',
    content: `
      <p>La mayoría de los canarios identifica a Intercasa por su emblemático kétchup, el producto más histórico y reconocido de la marca. No obstante, la empresa ha ampliado con éxito su gama de salsas incorporando referencias como la mayonesa, la mostaza dulce y el alioli receta canaria. Este último, lanzado hace apenas cinco años, se ha consolidado como uno de los más vendidos en las Islas gracias al uso de ingredientes frescos y naturales.</p>
      
      <p>Intercasa se prepara para reforzar su presencia en el mercado con dos nuevos lanzamientos: su salsa barbacoa, que llegará a los supermercados en mayo y que aspira a convertirse en una de las referencias más demandadas, y el kétchup 0% azúcares añadidos, cuyo desarrollo ha requerido casi un año para lograr un sabor fiel al clásico reconocido por los canarios. Ambos productos se presentarán en el tradicional envase de cristal, aunque la marca continúa diversificando su oferta con formatos antigoteo para responder a distintos usos y perfiles de consumo.</p>
      
      <p>La empresa también ha experimentado un cambio en la demanda: mientras que la crisis sanitaria redujo las ventas destinadas al sector hotelero, el consumo doméstico aumentó de manera notable gracias al apoyo del público canario. Intercasa destaca que esta confianza se debe a la calidad del producto local, la frescura asociada a la producción de kilómetro 0 y el impacto positivo que tiene apostar por marcas elaboradas en Canarias, tanto en empleo como en desarrollo industrial.</p>
    `,
    date: '2020-05-07',
    slug: 'ketchup-cero-azucares-anadidos',
    imageUrl: '/images/noticias/soy-canario-y-me-sabe.webp',
    imageAlt: 'Kétchup 0% azúcares añadidos de Intercasa',
    category: 'Innovación',
    source: 'Redacción digital - COPE',
    gallery: []
  },
  {
    id: 5,
    title: '70 años dando sabor a las mesas canarias',
    summary: 'Intercasa inició su actividad en 1949 en el barrio de Guanarteme, en Las Palmas de Gran Canaria, especializada en tomate frito y concentrado de tomate en lata, productos que pronto se convirtieron en su sello distintivo.',
    content: `
      <p>Intercasa inició su actividad en 1949 en el barrio de Guanarteme, en Las Palmas de Gran Canaria, especializada en tomate frito y concentrado de tomate en lata, productos que pronto se convirtieron en su sello distintivo. Su rápido crecimiento motivó en 1973 el traslado a Juan Grande, ubicación estratégica que permitió ampliar la capacidad de producción y situarse cerca de las zonas de cultivo que abastecen su elaboración.</p>
      
      <p>A lo largo de su trayectoria, Intercasa ha destacado por su vocación innovadora y su capacidad de adaptación a las demandas del mercado. En la década de los 90 amplió su presencia con el lanzamiento de la salsa barbacoa, incorporándola junto al tradicional ketchup en los lineales del Archipiélago. Con la llegada del nuevo siglo, la compañía inició un proceso de transformación orientado a un consumidor más exigente, que culminó en 2014 con una renovación de imagen más actual y cercana a un público joven.</p>
      
      <p>Ese mismo año amplió su catálogo con nuevas referencias como la mayonesa y el alioli receta canaria, acompañadas de un envase más funcional que se sumó al emblemático bote de cristal. Desde la dirección se destaca que el consumidor canario ha evolucionado notablemente con la expansión de las grandes superficies, aunque el sabor característico del ketchup Intercasa continúa siendo un elemento distintivo y valorado.</p>
      
      <p>Los pilares de la empresa se mantienen firmes: apuesta por la calidad de las materias primas, impulso constante a la innovación, compromiso con una alimentación saludable y respeto al medio ambiente, además de una fuerte vinculación con Canarias y las preferencias de sus consumidores. Mirando al futuro, Intercasa trabaja en nuevos sabores y en una línea sin azúcares añadidos, con el objetivo de seguir ocupando un lugar destacado en los hogares canarios.</p>
    `,
    date: '2018-09-17',
    slug: '70-anos-sabor-mesas-canarias',
    imageUrl: '/images/noticias/intercasa-70-anos.webp',
    imageAlt: 'Intercasa celebra 70 años dando sabor a las mesas canarias',
    category: 'Historia',
    source: 'La Provincia',
    gallery: [
      '/images/noticias/intercasa-70-anos-2.webp',
      '/images/noticias/intercasa-70-anos-3.webp'
    ]
  }
];

/**
 * Obtiene todas las noticias
 * @returns {Array} Array con todas las noticias
 */
export const getAllNews = () => {
  return newsData.sort((a, b) => new Date(b.date) - new Date(a.date));
};

/**
 * Obtiene una noticia por su slug
 * @param {string} slug - Slug de la noticia
 * @returns {Object|null} Noticia encontrada o null
 */
export const getNewsBySlug = (slug) => {
  return newsData.find(news => news.slug === slug) || null;
};

/**
 * Obtiene noticias por categoría
 * @param {string} category - Categoría de la noticia
 * @returns {Array} Array de noticias de la categoría
 */
export const getNewsByCategory = (category) => {
  return newsData
    .filter(news => news.category === category)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
};

/**
 * Obtiene las últimas N noticias
 * @param {number} limit - Número de noticias a devolver
 * @returns {Array} Array con las últimas noticias
 */
export const getLatestNews = (limit = 5) => {
  return getAllNews().slice(0, limit);
};

/**
 * Formatea una fecha para mostrar en español
 * @param {string} dateString - Fecha en formato string
 * @returns {string} Fecha formateada en español
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric',
    timeZone: 'Europe/Madrid'
  };
  return date.toLocaleDateString('es-ES', options);
};

/**
 * Convierte el código de categoría en texto legible
 * @param {string} category - Código de categoría o texto de categoría
 * @returns {string} Texto de la categoría en español
 */
export const getCategoryText = (category) => {
  const categories = {
    'sostenibilidad': 'Sostenibilidad',
    'produccion': 'Producción',
    'social': 'Acción Social',
    'calidad': 'Calidad',
    'innovacion': 'Innovación',
    'infraestructura': 'Infraestructura',
    'rrhh': 'Recursos Humanos',
    'medioambiente': 'Medio Ambiente',
    'empresa': 'Empresa',
    'comunidad': 'Comunidad'
  };
  
  // Si la categoría ya está en el formato correcto, la devuelve
  if (typeof category === 'string' && category.charAt(0) === category.charAt(0).toUpperCase()) {
    return category;
  }
  
  // Si es un código, lo convierte
  return categories[category.toLowerCase()] || category || 'Noticias';
};